import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227a3c5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      style: {"stop-color":"#dc2626","stop-opacity":"1"}
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "50%",
      style: {"stop-color":"#eab308","stop-opacity":"1"}
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      style: {"stop-color":"#16a34a","stop-opacity":"1"}
    })
  ])
], -1))
const _hoisted_3 = ["cx", "cy", "r", "stroke-width"]
const _hoisted_4 = ["cx", "cy", "r", "stroke", "stroke-width", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_5 = ["x", "y", "fill"]

import { ref, computed, watch, onMounted } from "vue";
import gsap from "gsap";

type GaugeSize = "small" | "medium" | "large";

interface Props {
  value: number | null;
  threshold?: number;
  size?: GaugeSize;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Gauge',
  props: {
    value: {},
    threshold: { default: 75 },
    size: { default: "medium" }
  },
  setup(__props: any) {

const props = __props;

const tweenedValue = ref(0);

const displayValue = computed(() => {
  if (props.value === null) return "N/A";
  return `${tweenedValue.value.toFixed(0)}%`;
});

const dimensions = computed(() => {
  switch (props.size) {
    case "small":
      return { size: 100, stroke: 8 };
    case "large":
      return { size: 180, stroke: 12 };
    default:
      return { size: 120, stroke: 10 };
  }
});

const viewBox = computed(() => {
  const size = dimensions.value.size;
  return `0 0 ${size} ${size}`;
});

const center = computed(() => dimensions.value.size / 2);
const radius = computed(() => dimensions.value.size / 2 - dimensions.value.stroke / 2);
const strokeWidth = computed(() => dimensions.value.stroke);
const circumference = computed(() => 2 * Math.PI * radius.value);

const dashOffset = computed(() => {
  const progress = tweenedValue.value / 100;
  return circumference.value * (1 - progress);
});

const strokeColor = computed(() => {
  const value = tweenedValue.value;
  if (value >= 80) return "#16a34a";
  if (value >= 60) return "#eab308";
  if (value >= 40) return "#ea580c";
  return "#dc2626";
});

const textColor = computed(() => {
  const value = tweenedValue.value;
  if (value >= 80) return "#166534";
  if (value >= 60) return "#854d0e";
  if (value >= 40) return "#9a3412";
  return "#991b1b";
});

watch(
  () => props.value,
  (newValue) => {
    if (newValue === null) {
      tweenedValue.value = 0;
      return;
    }
    gsap.to(tweenedValue, {
      duration: 0.75,
      value: Number(newValue) || 0,
      ease: "power2.out",
    });
  }
);

onMounted(() => {
  if (props.value === null) {
    tweenedValue.value = 0;
    return;
  }
  gsap.to(tweenedValue, {
    duration: 0.75,
    value: Number(props.value) || 0,
    ease: "power2.out",
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gauge-container", _ctx.size])
  }, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      viewBox: viewBox.value,
      preserveAspectRatio: "xMidYMid",
      class: "gauge"
    }, [
      _hoisted_2,
      _createElementVNode("circle", {
        cx: center.value,
        cy: center.value,
        r: radius.value,
        fill: "none",
        stroke: "#e2e8f0",
        "stroke-width": strokeWidth.value,
        "stroke-linecap": "round",
        transform: "rotate(-90 60 60)"
      }, null, 8, _hoisted_3),
      (props.value !== null)
        ? (_openBlock(), _createElementBlock("circle", {
            key: 0,
            cx: center.value,
            cy: center.value,
            r: radius.value,
            fill: "none",
            stroke: strokeColor.value,
            "stroke-width": strokeWidth.value,
            "stroke-linecap": "round",
            "stroke-dasharray": circumference.value,
            "stroke-dashoffset": dashOffset.value,
            transform: "rotate(-90 60 60)"
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("text", {
        x: center.value,
        y: center.value,
        "text-anchor": "middle",
        class: _normalizeClass(["percentage", _ctx.size]),
        fill: textColor.value,
        "dominant-baseline": "middle"
      }, _toDisplayString(displayValue.value), 11, _hoisted_5)
    ], 8, _hoisted_1))
  ], 2))
}
}

})